// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeamMemberEntry_memberEntry__cNzIU {
  display: flex;
  align-items: center;
  border-radius: var(--radius-default);
  height: var(--team-member-height);
  padding: calc(var(--gutter) / 4) calc(var(--gutter) / 2);
  gap: calc(var(--gutter) / 4);
  cursor: default;
  z-index: 1;
  background: var(--color-glass-card);
  border: 1px solid var(--color-border);
  transition: background 0.1s;
}
.TeamMemberEntry_memberEntry__cNzIU.TeamMemberEntry_dragging__nIir9 {
  opacity: 0.2;
  z-index: 999;
}

.TeamMemberEntry_memberEntry__cNzIU.TeamMemberEntry_admin__ZIVG0 {
  cursor: grab;
}
.TeamMemberEntry_memberEntry__cNzIU.TeamMemberEntry_admin__ZIVG0:hover {
  background: var(--color-surface-darker);
  border: 1px solid var(--color-border-highlight);
}

.TeamMemberEntry_memberEntry__cNzIU:not(.TeamMemberEntry_admin__ZIVG0) {
  pointer-events: none;
}
.TeamMemberEntry_memberEntry__cNzIU:not(.TeamMemberEntry_admin__ZIVG0):hover {
  background-color: inherit !important;
  border: 1px solid transparent !important;
}

.TeamMemberEntry_statusDefault__ZT2HT {
  background: var(--color-glass-card) !important;
}

.TeamMemberEntry_statusFocus__qOebM {
  background: var(--color-focus) !important;
}

.TeamMemberEntry_statusWatched__HuURz {
  background: var(--color-watched) !important;
}

.TeamMemberEntry_name__MKo16 {
  flex-grow: 1;
}

.TeamMemberEntry_statusIndicator__gKVNc {
  font-size: var(--font-size-smaller);
  margin-left: 0.25rem;
}`, "",{"version":3,"sources":["webpack://./src/components/TeamMemberEntry/TeamMemberEntry.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,iCAAA;EACA,wDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,mCAAA;EACA,qCAAA;EACA,2BAAA;AACF;AACE;EACE,YAAA;EACA,YAAA;AACJ;;AAIA;EACE,YAAA;AADF;AAGE;EACE,uCAAA;EACA,+CAAA;AADJ;;AAMA;EACE,oBAAA;AAHF;AAKE;EAEE,oCAAA;EACA,wCAAA;AAJJ;;AASA;EACE,8CAAA;AANF;;AASA;EACE,yCAAA;AANF;;AASA;EACE,2CAAA;AANF;;AASA;EACE,YAAA;AANF;;AASA;EACE,mCAAA;EACA,oBAAA;AANF","sourcesContent":[".memberEntry {\n  display: flex;\n  align-items: center;\n  border-radius: var(--radius-default);\n  height: var(--team-member-height);\n  padding: calc(var(--gutter) / 4) calc(var(--gutter) / 2);\n  gap: calc(var(--gutter) / 4);\n  cursor: default;\n  z-index: 1;\n  background: var(--color-glass-card);\n  border: 1px solid var(--color-border);\n  transition: background 0.1s;\n  \n  &.dragging {\n    opacity: 0.2;\n    z-index: 999;\n  }\n}\n\n// Show hover effects and enable interaction for admin users and user's own entries\n.memberEntry.admin {\n  cursor: grab;\n  \n  &:hover {\n    background: var(--color-surface-darker);\n    border: 1px solid var(--color-border-highlight);\n  }\n}\n\n// Ensure non-interactive entries don't change on hover\n.memberEntry:not(.admin) {\n  pointer-events: none; // Disable all mouse interactions\n  \n  &:hover {\n    // Use the !important flag to override any other styles\n    background-color: inherit !important;\n    border: 1px solid transparent !important;\n  }\n}\n\n// Status colors need !important to override the hover styles above\n.statusDefault {\n  background: var(--color-glass-card) !important;\n}\n\n.statusFocus {\n  background: var(--color-focus) !important;\n}\n\n.statusWatched {\n  background: var(--color-watched) !important;\n}\n\n.name {\n  flex-grow: 1;\n}\n\n.statusIndicator {\n  font-size: var(--font-size-smaller);\n  margin-left: 0.25rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"memberEntry": `TeamMemberEntry_memberEntry__cNzIU`,
	"dragging": `TeamMemberEntry_dragging__nIir9`,
	"admin": `TeamMemberEntry_admin__ZIVG0`,
	"statusDefault": `TeamMemberEntry_statusDefault__ZT2HT`,
	"statusFocus": `TeamMemberEntry_statusFocus__qOebM`,
	"statusWatched": `TeamMemberEntry_statusWatched__HuURz`,
	"name": `TeamMemberEntry_name__MKo16`,
	"statusIndicator": `TeamMemberEntry_statusIndicator__gKVNc`
};
export default ___CSS_LOADER_EXPORT___;
